import type { UseFormReturn } from "react-hook-form";
import { Type } from "@themes/pollinator/ui/Type";
import { Form } from "@themes/pollinator/ui/Form";
import { FormField } from "@themes/pollinator/ui/FormField";

const PARTNER_AGREEMENT_URL =
  "https://docs.google.com/document/d/1gWdwN3E8TtsxRJm-2L1XXFtpq6Qh7oAF/edit?usp=sharing&ouid=112082936655310092283&rtpof=true&sd=true";

export type Props = {
  /** react-hook-form instance */
  form: UseFormReturn<{ name: string }>;
};

/**
 * Presentational org display name step.
 * Renders a form for confirming/editing the organization's display name.
 */
export function OrgDisplayNameStep({ form }: Props) {
  const linkClassName = "underline hover:text-brand-600";

  return (
    <div className="flex-1 flex flex-col gap-6 p-6">
      <Type variant="h2">Organization Name</Type>

      <div className="flex-1 flex flex-col justify-center gap-6">
        <Type variant="body1" className="text-brand-700">
          Confirm your organization name. This is how your organization will appear to participants.
        </Type>

        <Form form={form} errorContainerClassName="p-0 w-full max-w-full mt-8">
          <FormField
            name="name"
            component="Input"
            placeholder="Enter your organization display name"
            size="hero"
            required
          />
        </Form>

        <Type variant="caption">
          By continuing, your organization joins Pollinator as a partner —
          committing to share the platform with your community — and agrees to
          the{" "}
          <a
            href={PARTNER_AGREEMENT_URL}
            target="_blank"
            rel="noopener noreferrer"
            className={linkClassName}
          >
            Partner Enrollment Agreement
          </a>
          ,{" "}
          <a
            href="/terms"
            target="_blank"
            rel="noopener noreferrer"
            className={linkClassName}
          >
            Terms of Service
          </a>
          , and{" "}
          <a
            href="/privacy"
            target="_blank"
            rel="noopener noreferrer"
            className={linkClassName}
          >
            Privacy Policy
          </a>
          .
        </Type>
      </div>
    </div>
  );
}

export default OrgDisplayNameStep;
